import apiClient from "../core/apiClient";

export async function upscaleFromUrl(sourceUrl) {
  const res = await apiClient.post("/sora/upscale-from-url", {
    source_url: sourceUrl,
  });
  return res.data;
}

export async function getJobStatus(runpodJobId) {
  const res = await apiClient.get(`/sora/jobs/status/${runpodJobId}`);
  return res.data;
}

export async function getMyJobs() {
  const res = await apiClient.get("/sora/jobs");
  return res.data.jobs;
}

export async function requestNoWatermark(sourceUrl) {
  const res = await apiClient.post("/sora/no-watermark", {
    source_url: sourceUrl,
  });
  return res.data;
}

export async function deleteJob(jobId) {
  await apiClient.delete(`/sora/jobs/${jobId}`);
}

export async function getSoraPricing() {
  const res = await apiClient.get("/sora/pricing");
  return res.data;
}

export async function getSoraPreview(url) {
  const res = await apiClient.get("/sora/preview", { params: { url } });
  return res.data;
}
